const axios = require('axios')

const api = axios.create({
    baseURL: `${process.env.VUE_APP_FLOW_MANAGER}`
})
export default api